import {
  Box,
  Divider,
  Paper,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { SpendXGetYMetadata } from '../../../interfaces/Offer/Metadata/SpendXGetY';
import { sharedStyles } from '../../../utils/Style';
import NumberInput from '../../../components/NumberInput/NumberInput';
import { CategoriesDropdown } from '../../../components/Dropdowns/CategoriesDropdown';
import { ProductsDropdown } from '../../../components/Dropdowns/ProductsDropdown';

type SpendXGetYFormProps = {
  value: SpendXGetYMetadata;
  onChange: (value: SpendXGetYMetadata) => void;
  disabled?: boolean;
  minWidth: number;
  maxWidth: number;
};

export const SpendXGetYForm = (props: SpendXGetYFormProps) => {
  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        p: 3,
        flexGrow: 1,
        minWidth: props.minWidth,
        maxWidth: props.maxWidth,
      }}
    >
      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        Kullanım Koşulları
      </Typography>
      <Divider />

      <NumberInput
        label='Minimum Sepet Tutarı'
        disabled={props.disabled}
        value={props.value.globalSpendLimit}
        onChange={(newValue) =>
          props.onChange({ ...props.value, globalSpendLimit: newValue })
        }
        acceptFloat
        endAdornment={<Typography>₺</Typography>}
      />

      <NumberInput
        label='Minimum Seçili Ürün Tutarı'
        disabled={props.disabled}
        value={props.value.spendLimit}
        onChange={(newValue) =>
          props.onChange({ ...props.value, spendLimit: newValue })
        }
        acceptFloat
        endAdornment={<Typography>₺</Typography>}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {props.value.applicableCategories ? (
          <Box sx={{ flex: '1 1 0', minWidth: 0 }}>
            <CategoriesDropdown
              label='Seçili Kategoriler'
              disabled={props.disabled}
              categoryIDs={props.value.applicableCategories}
              onChange={(newIDs) =>
                props.onChange({ ...props.value, applicableCategories: newIDs })
              }
            />
          </Box>
        ) : (
          <TextField
            label='Seçili Kategoriler'
            size='small'
            value='Tüm kategoriler'
            disabled
            fullWidth
          />
        )}

        <Switch
          disabled={props.disabled}
          checked={!!props.value.applicableCategories}
          onChange={() =>
            props.onChange({
              ...props.value,
              applicableCategories: props.value.applicableCategories
                ? undefined
                : [],
            })
          }
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {props.value.applicableProducts ? (
          <Box sx={{ flex: '1 1 0', minWidth: 0 }}>
            <ProductsDropdown
              label='Seçili Ürünler'
              multiple
              value={props.value.applicableProducts}
              disabled={props.disabled}
              onChange={(newIDs) =>
                props.onChange({ ...props.value, applicableProducts: newIDs })
              }
            />
          </Box>
        ) : (
          <TextField
            label='Seçili Ürünler'
            size='small'
            value='Tüm Ürünler'
            disabled
            fullWidth
          />
        )}

        <Switch
          disabled={props.disabled}
          checked={!!props.value.applicableProducts}
          onChange={() =>
            props.onChange({
              ...props.value,
              applicableProducts: props.value.applicableProducts
                ? undefined
                : [],
            })
          }
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {props.value.promotionCategories ? (
          <Box sx={{ flex: '1 1 0', minWidth: 0 }}>
            <CategoriesDropdown
              label='Promosyon Kategoriler'
              disabled={props.disabled}
              categoryIDs={props.value.promotionCategories}
              onChange={(newIDs) =>
                props.onChange({ ...props.value, promotionCategories: newIDs })
              }
            />
          </Box>
        ) : (
          <TextField
            label='Promosyon Kategoriler'
            size='small'
            value='Tüm kategoriler'
            disabled
            fullWidth
          />
        )}

        <Switch
          disabled={props.disabled}
          checked={!!props.value.promotionCategories}
          onChange={() =>
            props.onChange({
              ...props.value,
              promotionCategories: props.value.promotionCategories
                ? undefined
                : [],
            })
          }
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {props.value.promotionProducts ? (
          <Box sx={{ flex: '1 1 0', minWidth: 0 }}>
            <ProductsDropdown
              label='Promosyon Ürünler'
              multiple
              value={props.value.promotionProducts}
              disabled={props.disabled}
              onChange={(newIDs) =>
                props.onChange({ ...props.value, promotionProducts: newIDs })
              }
            />
          </Box>
        ) : (
          <TextField
            label='Promosyon Ürünler'
            size='small'
            value='Tüm ürünler'
            disabled
            fullWidth
          />
        )}

        <Switch
          disabled={props.disabled}
          checked={!!props.value.promotionProducts}
          onChange={() =>
            props.onChange({
              ...props.value,
              promotionProducts: props.value.promotionProducts ? undefined : [],
            })
          }
        />
      </Box>
    </Paper>
  );
};
